// src/types/financial.types.ts
export enum SourceOfFunds {
  EMPLOYMENT = 'EMPLOYMENT',
  SAVINGS = 'SAVINGS',
  WINNINGS = 'WINNINGS',
  MARITAL = 'MARITAL',
  REAL_ESTATE = 'REAL_ESTATE',
  TRUST = 'TRUST',
  INVESTMENT = 'INVESTMENT',
  OTHER = 'OTHER',
  COMPANY = 'COMPANY',
  COMPANY_CAPITAL = 'COMPANY_CAPITAL',
  LOAN = 'LOAN',
  PRIVATE_CAPITAL = 'PRIVATE_CAPITAL',
  GRANT = 'GRANT'
}

export enum AssetAmount {
  UPTO_10K = 'UPTO_10K',
  TEN_TO_100K = 'TEN_TO_100K',
  ONEHUNDREDK_TO_1M = 'ONEHUNDREDK_TO_1M',
  ONE_TO_10M = 'ONE_TO_10M',
  TEN_TO_50M = 'TEN_TO_50M',
  FIFTY_TO_250M = 'FIFTY_TO_250M', 
  MORE_THAN_250M = 'MORE_THAN_250M'
}

export enum MonthlyInvestmentAmount {
  UPTO_1K = 'UPTO_1K',
  ONE_TO_100K = 'ONE_TO_100K',
  ONEHUNDREDK_TO_1M = 'ONEHUNDREDK_TO_1M',
  MILLION_TO_5M = 'MILLION_TO_5M',
  MORE_THAN_5M = 'MORE_THAN_5M'
}

export enum DepositWithdrawalCount {
  UPTO_5 = 'UPTO_5',
  FIVE_TO_10 = 'FIVE_TO_10',
  TEN_TO_25 = 'TEN_TO_25',
  MORE_THAN_25 = 'MORE_THAN_25'
}

export interface FinancialInfoData {
  primarySourceOfFunds: SourceOfFunds;
  totalAssets: AssetAmount;
  monthlyInvestmentDeposit: MonthlyInvestmentAmount;
  monthlyDeposits: DepositWithdrawalCount;
  monthlyInvestmentWithdrawal: MonthlyInvestmentAmount;
  monthlyWithdrawals: DepositWithdrawalCount;
  usdValueOfFiat: AssetAmount;
  monthlyCryptoInvestmentDeposit: MonthlyInvestmentAmount;
  monthlyCryptoDeposits: DepositWithdrawalCount;
  monthlyCryptoInvestmentWithdrawal: MonthlyInvestmentAmount;
  monthlyCryptoWithdrawals: DepositWithdrawalCount;
  usdValueOfCrypto: AssetAmount;
}

export type ValidationErrors = Partial<Record<keyof FinancialInfoData, string>>;

// Añadir alias para compatibilidad
export { AssetAmount as TotalAssets };
export { MonthlyInvestmentAmount as MonthlyAmount };

export type FiatExchangeRates = {
  USD: number; // Base 1.0
  EUR: number;
  GBP: number;
  AED: number;
  MEX: number;
  PAN: number;
}